import { Component, Vue } from 'vue-property-decorator';
import GameStore from '@/store/GameStore';

@Component<HelloWorld>({
  computed: {
    players() {
      return GameStore.players;
    },
    cards() {
      return GameStore.cards;
    },
  },
})
export default class HelloWorld extends Vue {
  onConnect(): void {
    console.log('here');
  }

  onClick(): void {
    GameStore.shuffle();
    console.log('send');
  }
}
